import { forwardRef } from 'react';
import {
  Container,
  Header,
  HeaderText,
  CloseIcon,
  Copy,
  TooltipContainer,
  TooltipBody,
  Arrow,
} from './Tooltip.styled';

import { POSITION, VARIANT } from './Tooltip.typed';
import type { TooltipProps } from './Tooltip.typed';

import { accessibleOnClick } from '../../../utils/Accessibility';

const Tooltip = forwardRef<HTMLDivElement, TooltipProps>((props, ref) => {
  const {
    isOpen,
    children,
    headerText,
    headerFontSize = 'M16',
    headerFontWeight = 'bold',
    copy,
    askToClose,
    position = POSITION.ABOVE,
    variant = VARIANT.DARK,
    className,
    dataTrackingAttribute,
  } = props;

  return (
    <Container className={className} ref={ref}>
      {isOpen && (
        <TooltipContainer
          position={position}
          data-tracking={dataTrackingAttribute}
        >
          <TooltipBody variant={variant}>
            <Header>
              <HeaderText
                fontSize={headerFontSize}
                fontWeight={headerFontWeight}
                variant={variant}
              >
                {headerText}
              </HeaderText>

              {askToClose && (
                <CloseIcon
                  {...accessibleOnClick(
                    askToClose,
                    'button',
                    0,
                    'close-button',
                  )}
                  height={16}
                  width={16}
                  variant={variant}
                />
              )}
            </Header>

            {copy && <Copy variant={variant}>{copy} </Copy>}
            <Arrow position={position} variant={variant} />
          </TooltipBody>
        </TooltipContainer>
      )}
      {children}
    </Container>
  );
});

Tooltip.displayName = 'Tooltip';

export { Tooltip };
